// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2hmfz","emails":"CreateEditClinics_emails__1ADQC","emailTagLabel":"CreateEditClinics_emailTagLabel__2wg4X"};